module.exports = __webpack_public_path__ + "static/media/furniture.970e9770.png";